import { ComponentSpinner } from "@components/spinner";
import ManagedPayoutDashboard from "./components/managed-payout-dashboard";
import SelfPayoutDashboard from "./components/self-payout-dashboard";
import { UserContext } from "@src/utility/context/user";
import { useContext } from "react";
import useOpsDashboard from "./use-ops-dashboard";
import { PAYMENT_MODEL } from "@src/utility/constants/panel/common";

// The summary endpoint answers for whichever payment model the topbar toggle put
// on the `x-payment-model` header, and echoes it back — the two models have
// little in common, so each gets its own board.
const OpsDashboard = () => {
  const {
    stats,
    pendingActions,
    activeDebitNotes,
    paymentModel,
    generatedAt,
    loading,
    refreshing,
    refresh
  } = useOpsDashboard();

  if (loading) {
    return (
      <div className="flex justify-center py-24">
        <ComponentSpinner />
      </div>
    );
  }

  if (paymentModel === PAYMENT_MODEL.SELF_PAYOUT) {
    return (
      <SelfPayoutDashboard
        stats={stats}
        generatedAt={generatedAt}
        refreshing={refreshing}
        refresh={refresh} />
    );
  }

  return (
    <ManagedPayoutDashboard
      stats={stats}
      pendingActions={pendingActions}
      activeDebitNotes={activeDebitNotes}
      generatedAt={generatedAt}
      refreshing={refreshing}
      refresh={refresh} />
  );
};

const GenericDashboard = () => {
  const { userData: { user: { name, email, orgName, scope } = {} } = {} } =
    useContext(UserContext);

  return (
    <div className="p-6">
      <div className="grid grid-cols-12">
        <div className="col-span-12">
          <div className="rounded-lg border border-gray-200 bg-white shadow-sm">
            <div className="p-14">
              <h2 className="mb-4">Welcome, {name || email || "User"}</h2>
              <p className="mb-14 text-muted">
                Organization: <strong>{orgName || "—"}</strong>
                {scope && (
                  <span className="ml-6 inline-flex items-center rounded-full bg-primary px-2 py-0.5 text-xs font-semibold text-white">
                    {scope}
                  </span>
                )}
              </p>
              <hr />
              <p className="mb-0 text-muted">
                Cybersecurity Performance Management — Identify | Assess |
                Govern
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Dashboard = () => {
  const { userData } = useContext(UserContext);
  const role = userData?.user?.role;

  return role === "ops" ? <OpsDashboard /> : <GenericDashboard />;
};

export default Dashboard;
